import React, { Component } from "react";
import MainLayout from "../../components/layouts/main";
import Constants from "../../data/constants";
import EventPlaylistTableView from "../../components/views/EventPlaylistTableView";
import Data from "../../data/data";
import DndTest from "../../components/Dnd/DndTest";
import { connect } from "react-redux";
import {
  requestServerGet,
  selectBrand,
  selectPage,
  selectBranch,
  requestServerPost,
} from "../../actions";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";
import equal from "fast-deep-equal";
import { CopyToClipboard } from "react-copy-to-clipboard";

import { Table, DatePicker, TimePicker, message, Modal } from "antd";
import moment from "moment";
import Formats from "../../data/Formats";
import PopupManager from "../../managers/PopupManager";
import firebase from "../../Firebase";
import { useHistory } from "react-router-dom";
import DataHelper from "../../helpers/DataHelper";
import PeerHelper from "../../helpers/PeerHelper";
import ScreenStreamingPopup from "../../components/popups/ScreenStreamingPopup";
// import Modal from 'antd/lib/modal/Modal';
import { ExclamationCircleOutlined } from "@ant-design/icons";
import MediaPreviewPopup from "../../components/popups/MediaPreviewPopup";
import PermissionManager from "../../managers/PermissionManager";
import { SUB_FOLDER, SERVER_CONFIG } from "../../Config";
import { Zap as EventsIcon } from "lucide-react";
import PrimaryActionButton from "../../components/PrimaryActionButton";

const { Column, ColumnGroup } = Table;

const EventPage = (props) => {
  const history = useHistory();
  const { lang } = useProLanguage();
  return (
    <EventPageClass history={history} lang={lang} {...props}></EventPageClass>
  );
};

class EventPageClass extends Component {
  constructor(props) {
    super(props);
    this.childChangeCallbacks = [];
    this.state = { eventsData: [], branchData: null };
    this.mediaPreviewPopupRef = React.createRef();
  }

  componentDidMount() {
    this.reloadPage();
  }

  componentWillReceiveProps(props) {
    if ("selectedBranchData" in props) {
      if (props.selectedBranchData) {
        this.setState({ branchData: props.selectedBranchData }, () => {
          this.reloadPage();
        });
      }
    }
    if ("selectedBrandData" in props) {
      if (props.selectedBranchData) {
        this.setState({ brandData: props.selectedBrandData }, () => {
          this.reloadPage();
        });
      }
    }
  }

  componentDidUpdate(prevProps) {
    // if (!equal(this.props.selectedBranchData, prevProps.selectedBranchData)) // Check if it's a new user, you can also use some unique property, like the ID  (this.props.user.id !== prevProps.user.id)
    // {
    this.reloadPage();
    // }
  }

  reloadPage = () => {
    const {
      selectedBrandData,
      selectedBranchData,
      requestServerGet,
      userdata,
    } = this.props;

    if (selectedBrandData && !this.state.brandData) {
      this.setState({ brandData: selectedBrandData }, () => {
        this.reloadPage();
      });
      return;
    }
    if (selectedBranchData && !this.state.branchData) {
      this.setState({ branchData: selectedBranchData }, () => {
        this.reloadPage();
      });
      return;
    }

    if (!this.state.branchData) {
      return;
    }
    if (!this.state.brandData) {
      return;
    }
    requestServerGet(
      "get_eventplaylists",
      {
        brandid: this.state.brandData.BrandID,
        branchid: this.state.branchData.BranchID,
      },
      null,
      (response) => {
        console.log(" response.data " + JSON.stringify(response.data));
        this.setState({ eventsData: response.data });
      },
      userdata.token,
    );
  };

  componentDidUpdate() {}
  launchCreateEvent = () => {
    PopupManager.launchCreateScreenEventPopup(this.reloadPage);
  };

  // previewScreenCapture = (screendata) => {

  //     const { usertoken, requestServerGet, selectedBrandData } = this.props;

  //     requestServerGet("get_screenshot", { screenid: screendata.ScreenID }, null, (response) => {
  //         if (response.data.length) {

  //             const { ScreenShot = "" } = response.data[0]
  //             const d = { FileType: "image", FileID: -1, UploadFile: ScreenShot, scale: "contain" }
  //             if (this.mediaPreviewPopupRef.current) {
  //                 this.mediaPreviewPopupRef.current.previewMedia(d);
  //             }
  //         }
  //     }, usertoken)

  // }

  getScreensView = () => {
    const {
      usertoken,
      requestServerPost,
      selectPage,
      selectedBrandData,
      selectedBranchData,
      history,
      globalSearch,
    } = this.props;
    const t = (PRO_TRANSLATIONS[this.props.lang] || PRO_TRANSLATIONS.en)
      .eventPage;
    // console.log("getScreensView " + this.state.eventsData.length)

    const filteredData = this.state.eventsData.filter((data) => {
      return data.EventPlaylistName.toLocaleLowerCase().includes(
        globalSearch.toLocaleLowerCase(),
      );
    });

    const createPermission = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_SCREEN,
      PermissionManager.PERMISSION_TYPE_CREATE,
    );
    return (
      <MainLayout
        id={Constants.EVENT_PAGE}
        quietTitleBar={true}
        style={{ padding: 20 }}
        renderBreadCrumb={() => [
        <span style={{ fontSize: 14, fontWeight: 500, color: "#94a3b8", padding: "4px 8px", lineHeight: "22px" }}>
          {t.title || "Event"}
        </span>,
      ]}
      >
        <Modal
          centered
          footer={false}
          open={this.state.streamscreenvisible}
          width={"auto"}
          height="auto"
          closable={false}
          bodyStyle={{ backgroundColor: "black" }}
          onCancel={() => {
            this.setState({ streamscreenvisible: false });
            this.destroyPeer();
          }}
        >
          <video
            type="video/mp4"
            id="screenvideo"
            ref={this.videoRef}
            style={{ width: "auto", height: "600px" }}
          />
        </Modal>

        <div>
          {/* Page Header Bar */}
          <div className="cms-page-header">
            <div className="cms-page-header-info">
              <div
                className="cms-page-header-icon"
                style={{ background: "linear-gradient(135deg,#f59e0b,#d97706)" }}
              >
                <EventsIcon size={26} color="#fff" />
              </div>
              <div className="cms-page-header-text">
                <h1>{t.pageTitle}</h1>
                <p>{t.pageSubtitle}</p>
              </div>
            </div>
            {createPermission && (
              <PrimaryActionButton
                className="cms-page-header-action"
                onClick={this.launchCreateEvent}
              >
                {t.createEvent}
              </PrimaryActionButton>
            )}
          </div>

          <EventPlaylistTableView
            key="event_table_view"
            data={filteredData}
            onRowClicked={this.onCampaignContentClicked}
            onScreenClicked={(screenData) => {
              console.log("onScreenClicked " + screenData.ScreenID);
            }}
            onCampaignClicked={(screenData) => {
              if ("CampaignID" in screenData && screenData.CampaignID !== "") {
                // const path = `/${selectedBrandData.BrandID}/${selectedBranchData.BranchID}/campaign/${screenData.CampaignID}`

                // // history.push(path)
                // window.open(`${SERVER_CONFIG.SERVER_URI}${SUB_FOLDER}${path}`, "_self")

                selectPage(
                  Constants.CAMPAIGN_PAGE,
                  { id: screenData.CampaignID },
                  true,
                );
              } else {
                PopupManager.launchEditScreenPopup(screenData, () => {
                  this.reloadPage();
                });
              }
            }}
            onPlaylistClicked={(eventPlaylistData) => {
              if (
                "PlaylistID" in eventPlaylistData &&
                eventPlaylistData.PlaylistID !== ""
              ) {
                // const path = `/${selectedBrandData.BrandID}/${selectedBranchData.BranchID}/playlist/${eventPlaylistData.PlaylistID}`

                // // history.push(path)
                // window.open(`${SERVER_CONFIG.SERVER_URI}${SUB_FOLDER}${path}`, "_self")

                selectPage(
                  Constants.PLAYLIST_PAGE,
                  { id: eventPlaylistData.PlaylistID },
                  true,
                );
              }
            }}
            onDelete={(eventPlaylistData) => {
              const sData = eventPlaylistData;
              // console.log("delete screen " + JSON.stringify(screenData))
              // return
              requestServerPost(
                "delete_eventplaylist",
                { eventplaylistid: sData.EventPlaylistID },
                {},
                () => {
                  const t = (
                    PRO_TRANSLATIONS[this.props.lang] || PRO_TRANSLATIONS.en
                  ).eventPage;
                  message.success(t.deletedSuccess(sData.EventPlaylistName));
                  this.reloadPage();
                },
                usertoken,
              );
            }}
            onEdit={(screenData) => {
              PopupManager.launchEditScreenEventPopup(screenData, () => {
                this.reloadPage();
              });
              // console.log("edit edit")
            }}
          ></EventPlaylistTableView>
          <MediaPreviewPopup
            ref={this.mediaPreviewPopupRef}
          ></MediaPreviewPopup>
        </div>
      </MainLayout>
    );
  };

  render() {
    var view = this.getScreensView();
    return view;
  }
}

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    usertoken: state.usertoken,
    globalSearch: state.globalSearch,
    selectedBrandData: state.selectedBrandData,
    selectedBranchData: state.selectedBranchData,
  };
};

export default connect(mapStateToProps, {
  requestServerGet,
  requestServerPost,
  selectBrand,
  selectBranch,
  selectPage,
})(EventPage);
